import React, { PureComponent } from 'react'

import { Select } from 'components/FormField'
import options from './options'

import './codeBlock.scss'

class CodeBlock extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const { editor, attributes, node, children } = this.props

		return (
			<div {...attributes} className={`${attributes.className} c-code`}>
				<div className="c-code__toolbar" contentEditable={false}>
					<Select
						value={{
							value: node.data.get('language') || 'javascript',
							label: options[1].options.find(
								option =>
									option.value ===
									(node.data.get('language') || 'javascript')
							).label,
						}}
						options={options}
						onChange={event => {
							editor.setNodeByKey(node.key, {
								data: { language: event.value },
							})
						}}
						isSearchable
						useAlternativeStyle
						// menuPortalTarget={document.getElementsByClassName('o-page__content')[0]}
					/>
				</div>
				<div className="c-code__block">{children}</div>
			</div>
		)
	}
}

export default CodeBlock
